import React from "react"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => {
  return {
    toolbar: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      padding: 0,
      position: "relative",
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  }
})

export default function SiteHeaderSpacer() {
  const classes = useStyles()
  return <div className={classes.toolbar} elevation={5} />
}
